import alertDefaultStyle from './alertDefaultStyle';
import alertStyleDecorator from './alertStyleDecorator';
const alertStyleBuilder = (alertStyle, theme, displayCloseButton) => {
  let style = alertDefaultStyle(theme, displayCloseButton);
  style = alertStyleDecorator(alertStyle, style, theme);
  return style;
};
export default alertStyleBuilder;